<template>
	<div class="container">
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">数据监测</el-breadcrumb-item>
			<el-breadcrumb-item>抄表数据</el-breadcrumb-item>

		</el-breadcrumb>


		<el-row :gutter="20" ref="outBox">
			<el-col :span="18">
				<!-- 搜索筛选 -->
				<el-form :inline="true" class="user-search" label-position="left" label-width="80px">
					<el-form-item >
						 <el-date-picker
						  @change="getTime"
						  size="small"
						  v-model="timeDatas"
						  type="datetimerange"
						  range-separator="至"
						  start-placeholder="开始日期"
						  end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>

					<el-form-item>

						<el-button size="small" type="success" icon="el-icon-download" :loading="downloadLoadin" @click="exportdata">导出</el-button>
					</el-form-item>


					<el-form-item style="float: right;"  size="small" v-if="this.energyStr == '电力' || this.energyStr == '热能'">
						<el-select
              placeholder="选择数据项"
              multiple

              collapse-tags
              v-model="currEnergy"
              @change="dateItemChange"
            >
              <el-option
                v-for="item in dataOptions"
                :label="item.lable"
                :key="item.prop"
                :value="item.prop">
              </el-option>
            </el-select>
					</el-form-item>
				</el-form>

				<el-table size="small" :data="listData"  ref="chaobTable" highlight-current-row  v-loading="loading"   :max-height="tableHeight" border element-loading-text="拼命加载中"
				 style="width: 100%;" stripe :header-cell-style="this.$store.state.headerCss">
					<el-table-column align="center" type="index" width="60" label="序号">
					</el-table-column>
					<el-table-column  min-width="200" label="计量点名称" sortable  show-overflow-tooltip >
            <template slot-scope="scope" >
              <el-button type="text" @click="getFenLei(scope.row.terminalMeterPoint)" size="small">{{ scope.row.meterPointName }}</el-button>
            </template>
          </el-table-column>

					<el-table-column min-width="180"  prop="latestCollectTime" label="采集时间" ></el-table-column>
					<!-- <el-table-column min-width="180" prop="waterCumulant" label="水累计量"  v-if="energyStr == '水'"  ></el-table-column> -->
					<!-- <el-table-column min-width="180" prop="rate" label="费率" v-if="energyStr == '电力'"></el-table-column>
          <el-table-column min-width="180" prop="forwardActivePowerMeterCode" label="正向有功表码" v-if="energyStr == '电力'"></el-table-column> -->

          <template v-for="col in defaultCoulumn" >

          <!-- 	<el-table-column v-if="col.prop == 'hotTotalFlow'"  width="180" :label="col.lable">
              <template slot-scope="scope" >
                <span v-if='scope.row.hotTotalFlow'>{{scope.row.hotTotalFlow}}</span>
                <span v-else>--</span>
              </template>
            </el-table-column> -->
            <el-table-column  :prop="col.prop" :label="col.lable" width="180">

            </el-table-column>

          </template>

				</el-table>
			</el-col>
			<el-col :span="6" >

				<el-popover  v-model="visible" @show="setWidth">
					<el-input  ref="deptInput" class="cp" readonly slot="reference" autosize size="small" value="" placeholder="选择部门/集中器" v-model="getJZ"></el-input>
					<div :style="{ width: pW}">
						<el-tree v-loading="treeLoad" :data="treeDate"  :expand-on-click-node="false" :highlight-current="true"  @node-click="handleNodeClick"  :props="jzProps"  accordion  node-key='id'>
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span>
									<i v-if="!data.parentId && !data.isJz"  class="el-icon-office-building"></i>
									<i v-if="data.parentId"  class="el-icon-location-outline"></i>
									<i v-if="data.isJz"  class="el-icon-coin"></i>
									{{ data.departmentName }}
								</span>

							</span>

						</el-tree>
					</div>
				</el-popover>

				<el-select size="small" v-model="formInline.energyType" @change="changeEnergy" placeholder="能源类别" style="width: 100%;margin-top: 10px;">
					 <el-option
					  v-for="item in energyTypeList"
					  :key="item.id"
					  :label="item.value"
					  :value="item.id">
					</el-option>
				</el-select>
        <div style="margin-top: 10px; display: flex;">
          <el-input placeholder="请输入计量点地址"   @keyup.enter.native="getjlAndDetail"  v-model="formInline.meterPoint" size="small"></el-input>

        </div>
        <div style="margin-top: 10px; display: flex;">
          <el-input placeholder="请输入计量点名称"   @keyup.enter.native="getjlAndDetail"  v-model="formInline.meterPointName" size="small"></el-input>
          <el-button style="margin-left: 10px;" size="small"  type="primary"  @click="getjlAndDetail">搜索</el-button>
        </div>
				<div style="margin-top: 10px;">
					<el-table :header-cell-style="this.$store.state.headerCss"   ref="jltable" size="small" border :data="jlData" v-loading="loadJl" :height="tableHeightLeft"   @selection-change="handleSelectionChange">

						<!-- <el-table-column type="selection"  width="50"></el-table-column> -->
						<el-table-column  label="计量点名称"  prop="meterPointName"></el-table-column>
						<el-table-column label="用能单位"  prop="terminalInfoName"></el-table-column>
						<!-- <el-table-column label="计量点名称" prop="jlName" ></el-table-column> -->
					</el-table>
				</div>
				<el-pagination

				  @current-change="handleCurrentChange"
				  style="margin-top: 20px;"
				  background
				  v-if="showPage"
				  layout="prev, pager, next"
				  :pager-count="5"
				  :page-size="pageparm.pageSize"
				  :total="pageparm.totalCount"
				  >
				</el-pagination>

			</el-col>
		</el-row>

		<!-- 编辑界面 -->
		<el-dialog :visible.sync="editFormVisible"  @click="closeDialog" title="详情" width="90%">

      <el-form :inline="true" >

      	<el-form-item label="搜索：">
      		<div style="position: relative;top: 1px;">
      		<el-date-picker
      		  size="small"
      		  v-model="dataStr"
            value-format="yyyy-MM-dd"
      		  type="daterange"
      		  range-separator="至"
      		  start-placeholder="开始日期"
      		  @change="getDate"
      		  end-placeholder="结束日期">
      		</el-date-picker>
      		</div>
      	</el-form-item>
      	<el-form-item>
      		<el-button size="small" type="primary" icon="el-icon-search" @click="getFenLei()" >搜索</el-button>

      	</el-form-item>
      </el-form>
			<el-table size="small" border  height="300" :data="realDataTables" v-loading="loadReal"  :header-cell-style="this.$store.state.headerCss" >
				<el-table-column type="index" label="序号" width="60px"></el-table-column>
				<el-table-column label="计量点" prop="meterPointName"></el-table-column>
				<el-table-column label="用能单位" prop="energyUnit"></el-table-column>
				<el-table-column label="采集时间" prop="latestCollectTime" width="140"></el-table-column>
				<el-table-column label="倍率" prop="magnification" width="80" v-if="formInline.energyType == 15"></el-table-column>
				<el-table-column label="正向有功表码"  width="150"  prop="forwardActivePowerMeterCode" v-if="formInline.energyType == 15"></el-table-column>
        <el-table-column label="尖正向有功表码" width="150" prop="tipActivePowerMeterCode"  v-if="formInline.energyType == 15"></el-table-column>
        <el-table-column label="峰正向有功表码" width="150" prop="peakActivePowerMeterCode"  v-if="formInline.energyType == 15"></el-table-column>
        <el-table-column label="平正向有功表码" width="150" prop="flatActivePowerMeterCode"  v-if="formInline.energyType == 15"></el-table-column>
        <el-table-column label="谷正向有功表码" width="150" prop="ebbActivePowerMeterCode"  v-if="formInline.energyType == 15"></el-table-column>
        <el-table-column label="水累计量" prop="waterCumulant"  v-if="formInline.energyType == 16"></el-table-column>
        <el-table-column label="累计流量" prop="hotTotalFlow"  v-if="formInline.energyType == 18">

        </el-table-column>

			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="editFormVisible = false">取消</el-button>
			</div>
		</el-dialog>



	</div>
</template>

<script>
	import Chart from 'echarts'
	import {timestampToTime} from '@/utils/util'
	import 'echarts/theme/macarons.js'
	import {
		getAllConfigurationList,
		getDepartmentTerminalInfoLis,
		findMeterInfoList,
		getMeterReadingData,
		getTerminalInfoByDepId,
		getMeterReadingDataPoiFiter,
    getDetailRealData
	} from '../../api/energyMG'
	import Pagination from '../../components/Pagination'
	export default {
		data() {
			return {
				tableHeight:0,
				tableHeightLeft:0,
				dates:'',
				datatype: '',
				loading: true, //是显示加载
				loadJl:true,
				editFormVisible: false, //控制编辑页面显示与隐藏
				title: '添加',
        listData1:[],
				energyStr:'',
				visible:false,
				treeLoad:true,
				downloadLoadin:false,
				getJZ:"",
        showPage:true,
        dataStr:[
           new Date( new Date()-24 * 60 * 60 * 1000*10 ),
          new Date(),
        ],
				pW:"",
				jlData:[],
        currEnergy:[],
				editForm: {
					deptId: '',
					deptName: '',
					deptNo: '',
					token: localStorage.getItem('logintoken')
				},

        detailForm:{
          energyType:'15',
          terminalMeterPoint:"",
          startTime:"",
          endTime:""
        },


				// rules表单验证
				rules: {
					deptName: [{
						required: true,
						message: '请输入部门名称',
						trigger: 'blur'
					}],
					deptNo: [{
						required: true,
						message: '请输入部门代码',
						trigger: 'blur'
					}]
				},
				formInline: {
          meterPoint:"",
					energyType:"",
					terIds:JSON.stringify([]),
					meterPointName:'',
				  currentPage: 1,
					pageSize: 30,
          isRunning:""
				},

        realDataTables:[],
        loadReal:false,
				formInJl:{
					meterPointInfoIds:JSON.stringify([]),
					startTime:"",
					endTime:""

				},
        dataOptions:[],
        activeName: 'dianYa',
				treeDate:[],
				listData: [], //用户数据
				energyTypeList: [], //能源类别
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 30,
					totalCount: 0
				},
				jzProps:{
					label: function( data,node ){
						//console.log(data)
					},
					children: 'deps',

				},
				z_option: {
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: [],
					},
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            show: true,
            feature: {
              mark: {
                show: true
              },
              dataView: {
                show: true,
                readOnly: false
              },
              magicType: {
                show: true,
                type: ['line', 'bar']
              },
              restore: {
                show: true
              },
              saveAsImage: {
                show: true
              }
            }
          },

					calculable: true,
					xAxis: [{
						type: 'category',
						data: []
					}],
					yAxis: [{
						type: 'value',

					}],
					series: [

					]
				},

				timeDatas:[],
        defaultCoulumn:[],
        powerColumn:[
        	// {prop:"forwardActivePowerMeterCode",lable:"正向有功表码"},
          {prop:"tipActivePowerMeterCode",lable:"尖正向有功表码"},
          {prop:"peakActivePowerMeterCode",lable:"峰正向有功表码"},
          {prop:"flatActivePowerMeterCode",lable:"平正向有功表码"},
          {prop:"ebbActivePowerMeterCode",lable:"谷正向有功表码"},



        	{prop:"forwardReactivePowerMeterCode",lable:"正向无功表码(kWh)"},
        	{prop:"reverseActivePowerMeterCode",lable:"反向有功表码(kWh)"},
        	{prop:"reverseReactivePowerMeterCode",lable:"反向无功表码(kWh)"},
        	{prop:"combinationActivePowerMeterCode",lable:"组合有功表码(kWh)"},
        	{prop:"combinationReactivePowerMeterCode",lable:"组合无功表码(kWh)"},

        	{prop:"APhaseVoltage",lable:"A相电压(V)"},
        	{prop:"BPhaseVoltage",lable:"B相电压(V)"},
        	{prop:"CPhaseVoltage",lable:"C相电压(V)"},

        	{prop:"APhaseCurrent",lable:"A相电流(A)"},
        	{prop:"BPhaseCurrent",lable:"B相电流(A)"},
        	{prop:"CPhaseCurrent",lable:"C相电流(A)"},
          {prop:"psum",lable:"总有功功率"},
        	{prop:"APhaseActivePower",lable:"A相有功功率"},
        	{prop:"BPhaseActivePower",lable:"B相有功功率"},
        	{prop:"CPhaseActivePower",lable:"C相有功功率"},
        	{prop:"totalReactivePower",lable:"总无功功率"},
        	{prop:"APhaseReactivePower",lable:"A相无功功率"},
        	{prop:"BPhaseReactivePower",lable:"B相无功功率"},
        	{prop:"CPhaseReactivePower",lable:"C相无功功率"},

        	{prop:"powerFactor",lable:"总功率因数"},
        	{prop:"APowerFactor",lable:"A功率因数"},
        	{prop:"BPowerFactor",lable:"B功率因数"},
        	{prop:"CPowerFactor",lable:"C功率因数"}
        ],

        heatEnergy:[
          { prop:"hotSettlingDayData",lable:'结算日热量'},
          { prop:"nowHotData",lable:"当前热量" },
          { prop:"hotPower",lable:"热功率" },
          { prop:"hotFlow",lable:"流量" },

          { prop:"supplyWaterTemp",lable:"供水温度" },
          { prop:"returnWaterTemp",lable:"回水温度" },
          { prop:"totalWorkTime",lable:"累积工作时间" },
          { prop:"statusST",lable:"状态" }

        ]
			}
		},
		// 注册组件
		components: {
			Pagination
		},

		created() {
			this.getdata()
			this.initData()

		},
		computed:{

		},
		mounted(){
			this.$nextTick(() => {

				let out = this.$refs.chaobTable.$el.offsetTop + this.$refs.outBox.$el.offsetTop

				this.tableHeight = window.innerHeight - 175-60
				this.tableHeightLeft = window.innerHeight - 240 - 120

			})

		},


		methods: {





      getDate(val){
        console.log(val)
        this.detailForm.startTime = val[0]
        this.detailForm.endTime = val[1]
      },
      checkCol:function(type){

      	if(type == '电力'){
      		this.dataOptions = this.powerColumn
      	}else if(type == '水'){
      		this.dataOptions = this.waterColumn
      	}else if(type == '热能'){
      		this.dataOptions = this.heatEnergy
      	}


      },

      dateItemChange:function(val){
      	let col = val
        let arr = []

      	this.dataOptions.forEach(item => {
      		col.forEach(sitem => {
      			if(item.prop == sitem){
      				arr.push(item)
      			}
      		})
      	})


      	this.initDefault();
      	this.defaultCoulumn = [...this.defaultCoulumn,...arr]
      },

      initDefault:function(){

      	let tempArr = [

      	]

      	if(this.energyTypeStr == '电力'){
      		tempArr.push(
            {prop:"rate",lable:"费率"},
            {prop:"forwardActivePowerMeterCode",lable:"正向有功表码(kWh)"}
          )
          this.defaultCoulumn = tempArr
      	}else if( this.energyTypeStr == '水' ){
          tempArr.push({prop:"waterCumulant",lable:"水累计量(m3)"})
          this.defaultCoulumn = tempArr
        }else if( this.energyTypeStr == '热能'){
          tempArr.push({  prop:"hotTotalFlow",lable:"累积流量"  })
          this.defaultCoulumn = tempArr
        }
      },


			getD(sDate, endDate) {
				var sDate = new Date(this.formInJl.startTime);
				var eDate = new Date(this.formInJl.endTime);

				if (eDate.getFullYear() - sDate.getFullYear() > 1) { //先比较年
					return true;
				} else if (eDate.getMonth() - sDate.getMonth() > 1) { //再比较月
					return true;
				} else if (eDate.getMonth() - sDate.getMonth() == 1) {
					if (eDate.getDate() - sDate.getDate() >= 1) {
						return true;
					}
				} else if (eDate.getFullYear() - sDate.getFullYear() == 1) {
					if (eDate.getMonth() + 12 - sDate.getMonth() > 1) {
						return true;
					} else if (eDate.getDate() - sDate.getDate() >= 1) {
						return true;
					}
				}
				return false;
			},
			exportdata(){
				this.downloadLoadin = true
				if(this.getD()){
					this.$message({
					  message: '导出时间不能超过一个月',
					  type: 'warning'
					});
					this.downloadLoadin = false
					return
				}
				let param = { ...this.formInline,...this.formInJl }
				getMeterReadingDataPoiFiter(param).then(res => {

					var blob = new Blob([res], {type: 'application/vnd.openxmlformats-  officedocument.spreadsheetml.sheet;charset=utf-8'}); //type这里表示xlsx类型
					var downloadElement = document.createElement('a');
				　　var href = window.URL.createObjectURL(blob); //创建下载的链接
				　　downloadElement.href = href;
				　　downloadElement.download = 'result.xls'; //下载后文件名
				　　document.body.appendChild(downloadElement);
				　　downloadElement.click(); //点击下载
				　　document.body.removeChild(downloadElement); //下载完成移除元素
				　　window.URL.revokeObjectURL(href); //释放掉blob对象

					this.downloadLoadin = false

				}).catch(err => {
					this.downloadLoadin = false
					this.$message({
						message:'下载失败！',
						type:'error',
						showClose:true
					})
				})

			},
			handleNodeClick(data){
				this.getJZ = data.departmentName
				if(data.isJz){
					let idstr = JSON.stringify([{id:data.id}])
					this.formInline.terIds = idstr
				}else{
					//点击部门获得集中器id
					getTerminalInfoByDepId({depId:data.id}).then(res => {

						if(res.status == 1){
							let arr = []
							res.data.forEach( item => {
								let obj = {}
								obj.id = item
								arr.push(obj)
							})
							this.formInline.terIds = JSON.stringify(arr)
						}else{
							this.$message.error(res.msg)
						}
					})
				}
				this.visible = false
				//this.getJlData()
			},
			setWidth(e){
				this.pW = this.$refs.deptInput.$el.offsetWidth-30 + 'px'
			},

			handleSizeChange:function(val){
				this.pageparm.pageSize = val
				this.getJlData();

			},
			handleCurrentChange:function(val){
				this.pageparm.currentPage = val
				this.formInline.currentPage = val

				this.getJlData();
			},


			getdata(){
				let date = new Date();
				let year = date.getFullYear();
				let month = date.getMonth();
				let strDate = date.getDate();
				this.timeDatas = [ new Date(year, month, strDate, 0, 0), new Date(year, month, strDate, 23, 59)]


				this.formInJl.startTime = timestampToTime(new Date(year, month, strDate, 0, 0))
				this.formInJl.endTime = timestampToTime(new Date(year, month, strDate, 23, 59))
				// this.timeDatas = [ new Date(year, month, strDate, 00, 00), new Date(year, month, strDate, 23, 59) ]



			},

			getTime(e){

				this.formInJl.startTime = timestampToTime(this.timeDatas[0])
				this.formInJl.endTime = timestampToTime(this.timeDatas[1])

			},

			getFenLei(val){
				  this.editFormVisible = true
          this.loadReal = true
          if( val){
             this.detailForm.terminalMeterPoint = val
             this.dataStr = [
                new Date( new Date()-24 * 60 * 60 * 1000*10 ),
               new Date(),
             ],
             this.detailForm.startTime = timestampToTime( new Date( new Date()-24 * 60 * 60 * 1000*10 )).substring(0,10)
             this.detailForm.endTime = timestampToTime(new Date()).substring(0,10)
          }

          getDetailRealData(this.detailForm).then(res => {
             this.loadReal = false
            if(res.status == 1){
              this.realDataTables = res.data.result
            }
          })




        	// this.chart = Chart.init(this.$refs.fengLei, 'macarons')
        	// this.chart.setOption(this.z_option)
          this.setChart()
				this.$nextTick(() => {

				})
			},
			//获取所有配置选项
			getConfigData:function(){
					getAllConfigurationList().then(res => {
						if(res.status == 1){
							this.energyTypeList = res.data.energyType
							this.formInline.energyType = this.energyTypeList[0].id
              this.energyTypeStr = res.data.energyType[0].value
							this.energyStr = this.energyTypeList[0].value
              let type = res.data.energyType[0].value
              this.checkCol(type)
              this.initDefault()
						}else{
							this.$message.error(res.msg)
						}
					})

			},

			changeEnergy( val ){
				this.formInline.energyType = val
				this.detailForm.energyType = val

				this.energyStr = this.energyTypeList.filter(item => item.id == val)[0].value
        this.defaultCoulumn = []
        this.currEnergy = [];
        let lable = this.energyTypeList.filter(item => item.id == val)
        this.energyTypeStr = lable[0].value
        this.initDefault()

				this.getJlData();  //计量点

				this.getJlCbData();
        this.checkCol(lable[0].value)
			},

			//根据计量点名称获取计量点信息以及更新抄表数据
			getjlAndDetail:function(){
				this.loadJl = true
				this.formInline.currentPage = 1
				this.showPage = false
				findMeterInfoList(this.formInline).then(res => {
					this.loadJl = false
					if(res.status == 1){
						this.jlData = res.data.data
            this.pageparm.totalCount = res.data.totalCount

            console.log(this.pageparm.totalCount)

						let arr = this.jlData.map( item => {
							return{ id: item.id}
						})
						return JSON.stringify(arr)

					}
				}).then( result =>{
					console.log('result==',result)
					this.formInJl.meterPointInfoIds = result
					this.$nextTick( ()=> {
						// this.$refs.jltable.toggleAllSelection();
					})
					this.getJlCbData();

				})

        this.$nextTick(()=>{
          this.showPage = true
        })

			},
			//获取集中器信息
			getJzData:function(){
				return new Promise((resolve,reject) => {
					getDepartmentTerminalInfoLis().then(res => {
						this.treeLoad = false
						if(res.status == 1){
							let arr = []
							this.treeDate = this.changeData(res.data.menuDepList)
							res.data.terIds.forEach(item => {
								let obj ={}
								obj.id = item
								arr.push(obj)
							})
							this.formInline.terIds = JSON.stringify(arr)
							resolve(res.data.terIds)
						}
						else{
							this.$message.error(res.msg)
						}
					})
				})

			},
			handleSelectionChange(e){


				// this.formInJl.meterPointInfoIds
			},

			//获取计量点抄表信息
			getJlCbData(){
				this.loading = true
				let param = { ...this.formInline,...this.formInJl }


				getMeterReadingData(param).then(res => {
					this.loading = false
					if(res.status == 1){
						this.listData = res.data.result
					}else{
						this.listData = []
					}
				})
			},

			async initData(){

				await this.getConfigData(); //获取配置


				await this.getJzData();  //集中器
				await this.getJlData();  //计量点



			},


			//获取计量点信息
			getJlData:function(){
				this.loadJl = true
				let param = {...this.pageparm,...this.formInline}

				return new Promise((resolve,reject) => {
					findMeterInfoList(param).then(res => {
						if(res.status == 1){


							this.loadJl = false
							this.jlData = res.data.data

							this.pageparm.currentPage = this.formInline.currentPage
							this.pageparm.pageSize = this.formInline.pageSize
							this.pageparm.totalCount = res.data.totalCount

							let arr = this.jlData.map( item => { return { id:item.id} } )

				 			this.formInJl.meterPointInfoIds = JSON.stringify(arr)
							//resolve(JSON.stringify(arr) )
							this.getJlCbData();
						}else{
							this.loadJl = false
							this.$message.error(res.msg)
						}
					})
					.catch( err =>{
						this.loadJl = false
						this.$message.error(err)
					})
				})

			},


			selectedDefault(i){
				this.$nextTick( ()=> {
					this.$refs.jltable.toggleRowSelection(this.jlData[i],true);
				})
			},

			changeData( data ){
				data.forEach(item =>{
					if( item.terminalInfo){
						if(!item.deps){
							item.deps = []
						}
						item.terminalInfo.forEach(sitem => {
							let obj = {}
							obj.id = sitem.id
							obj.departmentName = sitem.terminalName
							obj.terminalCode = sitem.terminalCode
							obj.isJz= true
							item.deps.push(obj)
						})
					}

					if( item.deps){
						this.changeData(item.deps)
					}
				})

				return  data
			},


			// 分页插件事件
			callFather(parm) {

				console.log(parm)
				this.formInline.currentPage = parm.currentPage
				this.formInline.pageSize = parm.pageSize
				this.getdata(this.formInline)
			},
			// 搜索事件
			search() {
				this.getdata(this.formInline)
			},

			closeDialog() {
				this.editFormVisible = false
			}
		}
	}
</script>

<style >
  .el-popover{
    max-height: 260px !important;
    overflow-y: scroll;
  }
	.user-search {

	}

	.userRole {
		width: 100%;
	}
	.cavasbox {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
	}

	.paybox {
		width: 100%;
		background-color: #fff;
		box-sizing: border-box;
		border-radius: 5px;

		height: 32vh;
	}
	.cp .el-input__inner{
		cursor: pointer;
	}

	.el-tree-node {
		margin: 5px 0;
	}
</style>



// WEBPACK FOOTER //
// src/views/datamonitoring/meterData.vue